import type React from "react";

type Props = {
    name: string;
    value?: string | ReadonlyArray<string> | number;
    handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};
export default function Checkbox({ name, value, handleChange }: Props) {
    return (
        <input
            type="checkbox"
            name={name}
            value={value}
            className="rounded border-gray-300 text-indigo-600 shadow-sm focus:ring-indigo-500"
            onChange={(e) => handleChange(e)}
        />
    );
}
